import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { editorUpdateCopy } from '../../../../../../store/pages-management/actions'
import { CTAProps as Props } from './types'
 
const CTA: FC<Props> = ({ strings, copy }) => {
  // REDUX STORE
  const dispatch = useDispatch()

  return (
    <div className="part cta">
      <h3 className="part_header">{ strings.call_to_action }</h3>
      <div>
        <input
          type="text"
          className="grey full-width"
          value={ copy.button }
          onChange={ (e) => dispatch(editorUpdateCopy({ ...copy, button: e.target.value })) }
        />
      </div>
    </div>
  )
}
 
export default CTA
 